import { readContract } from '@wagmi/core';
import { config } from './walletConfig';
import { abi } from './multi_abi';
import addresses from './addresses';
import { Interface } from 'ethers';
import { abi as pctAbi } from '@/composables/pct_abi';
import { abi as xpctAbi } from '@/composables/xpct_abi';
import { abi as pcdAbi } from '@/composables/pcd_abi';
import { abi as proMineAbi } from '@/composables/pro_mine_abi';
import { abi as usdtAbi } from '@/composables/erc_abi';


import utils from '@/composables/utils';
const { convertToWei, convertFromWei } = utils;

// All batch reads use the same verified Polygon fallback transport as single reads.
export async function multiCall(targets, data) {
  return readContract(config, { chainId: 137, abi, address: addresses.multiCallContractAddress,
    functionName: 'multiCall', args: [targets, data] });
}
export async function multiCallForSingle(target, data) {
  return readContract(config, { chainId: 137, abi, address: addresses.multiCallContractAddress,
    functionName: 'multiCallForSingle', args: [target, data] });
}

export async function fetchAllWalletData(address) {
  // 地址有效性檢查與日誌
  if (!address || typeof address !== 'string' || !address.startsWith('0x') || address.length !== 42) {
    console.error('[fetchAllWalletData] 無效地址:', address);
    throw new Error('[fetchAllWalletData] address is invalid: ' + address);
  } else {
    console.log('[fetchAllWalletData] address:', address);
  }
  const calls = [
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('balanceOf', [address])
    },
    {
      target: addresses.proMineContractAddress,
      callData: new Interface(proMineAbi).encodeFunctionData('getMiningPoolCount', [address])
    },
    {
      target: addresses.usdtContractaddress,
      callData: new Interface(usdtAbi).encodeFunctionData('balanceOf', [address])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('balanceOf', [address])
    },
    {
      target: addresses.xpctContractAddress,
      callData: new Interface(xpctAbi).encodeFunctionData('balanceOf', [address])
    },
    {
      target: addresses.xpctContractAddress,
      callData: new Interface(xpctAbi).encodeFunctionData('totalSupply', [])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('balanceOfAvailable', [address])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('balanceOfShares', [address])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('dividendOf', [address])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('accumulativeDividendOf', [address])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('getTotalSharesForDividends', [])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('addressState', [address])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('getReferralIncomes', [address])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('userDonateCount', [address])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('selfReferralCount', [address])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('selfReferralDonateCount', [address])
    },
    {
      target: addresses.proMineContractAddress,
      callData: new Interface(proMineAbi).encodeFunctionData('getMiningPerBlock', [address])
    },
    {
      target: addresses.proMineContractAddress,
      callData: new Interface(proMineAbi).encodeFunctionData('miningSpeed', [address])
    },
    {
      target: addresses.proMineContractAddress,
      callData: new Interface(proMineAbi).encodeFunctionData('getTotalMiningOutput', [address])
    },
    {
      target: addresses.proMineContractAddress,
      callData: new Interface(proMineAbi).encodeFunctionData('getRemainingMiningOutput', [address])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('directorUpgradeCount', [])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('allowance', [address, addresses.xpctContractAddress])
    },
    {
      target: addresses.xpctContractAddress,
      callData: new Interface(xpctAbi).encodeFunctionData('directorOnly', [])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('getPriceETH', [])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('upgradeFeeUSDT', [])
    },
    {
      target: addresses.pctContractAddress,
      callData: new Interface(pctAbi).encodeFunctionData('availableBalanceOf', [address])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('tokenPrice', [])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('getClaimedPCD', [address])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('minPineForClaim', [])
    },
    {
      target: addresses.pcdContractAddress,
      callData: new Interface(pcdAbi).encodeFunctionData('getClaimablePCD', [address])
    },

  ];

  // 調用前打印所有 call 參數，方便調試
  calls.forEach((c, idx) => {
    try {
      const decoded = new Interface(
        c.target === addresses.pcdContractAddress ? pcdAbi :
        c.target === addresses.pctContractAddress ? pctAbi :
        c.target === addresses.xpctContractAddress ? xpctAbi :
        c.target === addresses.proMineContractAddress ? proMineAbi :
        c.target === addresses.usdtContractaddress ? usdtAbi : []
      ).parseTransaction({ data: c.callData });
      console.log(`[multiService] call[${idx}]:`, decoded.name, decoded.args);
    } catch (e) {
      console.log(`[multiService] call[${idx}]:`, c);
    }
  });

  const targets = calls.map(c => c.target);
  const dataArr = calls.map(c => c.callData);
  const results = await multiCall(targets, dataArr);

  let i = 0;
  const toNumber = (value) => {
    if (typeof value === 'bigint') {
      return Number(value);
    }
    return value;
  };

  return {
    pctBalance: convertFromWei(new Interface(pctAbi).decodeFunctionResult('balanceOf', results[i++])[0],18,2),
    pineCount: toNumber(new Interface(proMineAbi).decodeFunctionResult('getMiningPoolCount', results[i++])[0]),
    usdtBalance: convertFromWei(new Interface(usdtAbi).decodeFunctionResult('balanceOf', results[i++])[0],6,6),
    pcdBalance: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('balanceOf', results[i++])[0],18,2),
    xpctBalance: convertFromWei(new Interface(xpctAbi).decodeFunctionResult('balanceOf', results[i++])[0],18,2),
    totalStaked: convertFromWei(new Interface(xpctAbi).decodeFunctionResult('totalSupply', results[i++])[0],18,2),
    balanceOfAvailable: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('balanceOfAvailable', results[i++])[0],18,2),
    balanceOfShares: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('balanceOfShares', results[i++])[0],18,2),
    dividendOf: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('dividendOf', results[i++])[0],6,6),
    accumulativeDividendOf: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('accumulativeDividendOf', results[i++])[0],6,6),
    totalSharesForDividends: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('getTotalSharesForDividends', results[i++])[0],18,2),
    accountType: toNumber(new Interface(pctAbi).decodeFunctionResult('addressState', results[i++])[0]),
    referralIncomes: convertFromWei(new Interface(pctAbi).decodeFunctionResult('getReferralIncomes', results[i++])[0],18,2),
    userDonateCount: toNumber(new Interface(pctAbi).decodeFunctionResult('userDonateCount', results[i++])[0]),
    selfReferralCount: toNumber(new Interface(pctAbi).decodeFunctionResult('selfReferralCount', results[i++])[0]),
    selfReferralDonateCount: toNumber(new Interface(pctAbi).decodeFunctionResult('selfReferralDonateCount', results[i++])[0]),
    miningPerBlock: toNumber(new Interface(proMineAbi).decodeFunctionResult('getMiningPerBlock', results[i++])[0]),
    miningSpeed: toNumber(new Interface(proMineAbi).decodeFunctionResult('miningSpeed', results[i++])[0]),
    totalMiningOutput: convertFromWei(new Interface(proMineAbi).decodeFunctionResult('getTotalMiningOutput', results[i++])[0],18,2),
    remainingMiningOutput: convertFromWei(new Interface(proMineAbi).decodeFunctionResult('getRemainingMiningOutput', results[i++])[0],18,2),
    directorUpgradeCount: toNumber(new Interface(pctAbi).decodeFunctionResult('directorUpgradeCount', results[i++])[0]),
    pctAllowanceToXpct: convertFromWei(new Interface(pctAbi).decodeFunctionResult('allowance', results[i++])[0],18,2),
    directorOnly: toNumber(new Interface(xpctAbi).decodeFunctionResult('directorOnly', results[i++])[0]),
    polPrice: convertFromWei(new Interface(pctAbi).decodeFunctionResult('getPriceETH', results[i++])[0], 8, 6),
    pinePrice: convertFromWei(new Interface(pctAbi).decodeFunctionResult('upgradeFeeUSDT', results[i++])[0], 18, 2),
    availableBalance: convertFromWei(new Interface(pctAbi).decodeFunctionResult('availableBalanceOf', results[i++])[0], 18, 2),
    pcdPrice: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('tokenPrice', results[i++])[0], 18, 2),
    getClaimedPCD: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('getClaimedPCD', results[i++])[0], 18, 2),
    minPineForClaim: toNumber(new Interface(pcdAbi).decodeFunctionResult('minPineForClaim',results[i++])[0]),
    getClaimablePCD: convertFromWei(new Interface(pcdAbi).decodeFunctionResult('getClaimablePCD', results[i++])[0],18,6)
  };
} 
